import React from "react";
import { useSelector } from "react-redux";
import { RetailersFilterPage } from "../retailerFilter/RetailerFilterPage";
import { RetailerTablePage } from "../retailerTable/RetailerTablePage";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

import classes from "./retailerListPage.module.css";
import { selectRetailerState } from "../../../store/retailer/retailerFilterSlice";
import { selectRetailers, useGetRetailersListQuery } from "../../../services/retailers/retailersApiSlice";

export const RetailerListPage = () => {
  const appliedFilters = useSelector(selectRetailerState);
  const { isSuccess } = useGetRetailersListQuery(appliedFilters);

  const tableData = useSelector(selectRetailers);

  return isSuccess ? (
    <div className={classes.box}>
      <RetailersFilterPage filters={appliedFilters} />
      <RetailerTablePage data={tableData} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
